import {
  Clock,
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  MapPin,
  MessageCircle,
  Phone,
  Twitter,
} from "lucide-react";
import React from "react";
import SimpleForm from '../components/SimpleForm';
import Footer from "./Footer";


const ContactUs = () => {
  return (
    <div>
      <div className="relative bg-gradient-to-r from-[#F7EDE2] to-[#F5CAC3] py-24 px-4 sm:px-6 lg:px-8 overflow-hidden">
        <div className="max-w-7xl mx-auto text-center relative z-10">
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6">
            Get in Touch with Nestora
          </h1>
          <p className="text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto">
            We're here to help with any questions about our products, services,
            or your order.
          </p>
        </div>
        <div className="absolute inset-0 opacity-20">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1577979749830-f1d742b96791?auto=format&fit=crop&q=80')] bg-cover bg-center"></div>
        </div>
      </div>
      {/* Contact Information */}
      <div className="contact flex  flex-wrap justify-center items-center gap-24 bg-slate-100/40 mb-8">
      <div>
        <div className="mt-14">
          <h2 className="text-3xl font-serif font-bold text-gray-900 mb-8">
            Contact Information
          </h2>

          <div className="space-y-6 ">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#F5CAC3] rounded-full flex items-center justify-center">
                  <MapPin className="w-6 h-6 text-[#E07A5F]" />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-bold text-gray-900">Our Address</h3>
                <p className="text-gray-600 mt-1">
                  123 Furniture Lane
                  <br />
                  Design District
                  <br />
                  San Francisco, CA 94107
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#F5CAC3] rounded-full flex items-center justify-center">
                  <Phone className="w-6 h-6 text-[#E07A5F]" />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-bold text-gray-900">Phone</h3>
                <p className="text-gray-600 mt-1">
                  Customer Service: (555) 123-4567
                  <br />
                  Sales Inquiries: (555) 765-4321
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#F5CAC3] rounded-full flex items-center justify-center">
                  <Mail className="w-6 h-6 text-[#E07A5F]" />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-bold text-gray-900">Email</h3>
                <p className="text-gray-600 mt-1">
                  Customer Support: support@nestora.com
                  <br />
                  Sales: sales@nestora.com
                  <br />
                  Press: media@nestora.com
                </p>
              </div>
            </div>

            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-[#F5CAC3] rounded-full flex items-center justify-center">
                  <Clock className="w-6 h-6 text-[#E07A5F]" />
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-bold text-gray-900">
                  Business Hours
                </h3>
                <p className="text-gray-600 mt-1">
                  Monday - Friday: 9:00 AM - 6:00 PM
                  <br />
                  Saturday: 10:00 AM - 4:00 PM
                  <br />
                  Sunday: Closed
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12">
          <h3 className="text-xl font-bold text-gray-900 mb-4">
            Connect With Us
          </h3>

          <div className="flex flex-wrap gap-4 mb-8">
            <a
              href="#"
              className="flex items-center px-6 py-3 bg-[#25D366] text-white rounded-lg hover:bg-opacity-90 transition-all"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp
            </a>
            <a
              href="#"
              className="flex items-center px-6 py-3 bg-[#0084FF] text-white rounded-lg hover:bg-opacity-90 transition-all"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              Messenger
            </a>
          </div>

          <div className="flex space-x-4">
            <a
              href="#"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all hover:bg-[#E1306C]/30"
              aria-label="Instagram"
            >
              <Instagram className="w-6 h-6 text-[#E1306C]" />
            </a>
            <a
              href="#"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all hover:bg-[#1877F2]/30"
              aria-label="Facebook"
            >
              <Facebook className="w-6 h-6 text-[#1877F2]" />
            </a>
            <a
              href="#"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all hover:bg-[#1DA1F2]/30"
              aria-label="Twitter"
            >
              <Twitter className="w-6 h-6 text-[#1DA1F2]" />
            </a>
            <a
              href="#"
              className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm hover:shadow-md transition-all hover:bg-[#0A66C2]/30"
              aria-label="LinkedIn"
            >
              <Linkedin className="w-6 h-6 text-[#0A66C2]" />
            </a>
          </div>
        </div>
      </div>
      
        <SimpleForm/>
      </div>
      <Footer/>
    </div>
  );
};

export default ContactUs;
